import { cn } from "@/utils";
import { FormButton } from "../forms";

export type TAuthPrimaryButtonProps = React.ComponentProps<typeof FormButton> & {
  fullWidth?: boolean;
};

export function AuthPrimaryButton({ fullWidth, className, size, ...props }: TAuthPrimaryButtonProps) {
  return (
    <FormButton
      size={size ?? "lg"}
      className={cn("h-11 font-medium", fullWidth ? "w-full" : "w-full sm:w-fit sm:px-10", className)}
      {...props}
    />
  );
}
